import AnswerDetails from 'stores/FormDetails/AnswerDetails';
import { SelectedAnswerType } from 'utils/api/modules/workflows/workflows.types';

import { colors } from 'theme/colors';

export interface QuestionRowProps {
  answer: AnswerDetails;
  isSubmitted: boolean;
  updateAnswer: (answerKey: string, selectedAnswer: SelectedAnswerType) => Promise<void>;
  updating?: boolean;
}

export const ScoreChipColors = {
  orange: '#E65100',
  blue: colors.primary.main,
  yellow: '#FBC02D',
  green: '#2e7d32',
};
